<script setup lang="ts">
import { computed, defineProps, defineEmits } from "vue";

// 추후 사이즈 추가 예정
interface Props {
    value: boolean;
    onColor?: string;
    offColor?: string;
    disabled?: boolean;
}

const props = defineProps<Props>();
const emit = defineEmits<{
    (event: "emit-toggle-state", value: boolean): void;
}>();

// 반응형 상태 (props 변경 감지)
const isChecked = computed(() => props.value);

// 크기별 클래스 설정
const sizeClasses = computed(() => {
    return {
        switch: "w-[5.2rem] h-[3.2rem]",
        thumb: {
            checked: "w-[2.4rem] h-[2.4rem] bg-white",
            unchecked: "w-[1.4rem] h-[1.4rem] bg-primary-gray",
        },
        translate: "translate-x-[2.2rem]",
    };
});

// 동적 배경색 스타일
const switchStyle = computed(() => ({
    backgroundColor: isChecked.value ? props.onColor || "#f87171" : props.offColor || "#F4F4F3",
    border: isChecked.value ? "none" : "2px solid #85898A",
}));

// 토글 버튼 클릭 핸들러
const toggle = () => {
    if (!props.disabled) {
        emit("emit-toggle-state", !isChecked.value);
    }
};
</script>

<template>
    <button
        :aria-checked="isChecked"
        role="switch"
        :style="switchStyle"
        :class="[
            'relative flex items-center rounded-full py-[0.4rem] px-[0.2rem] transition duration-300',
            sizeClasses.switch,
            disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer',
        ]"
        @click="toggle"
    >
        <span
            class="absolute transition-all duration-300 rounded-full shadow-md left-1"
            :class="
                isChecked
                    ? [sizeClasses.thumb.checked, sizeClasses.translate]
                    : [sizeClasses.thumb.unchecked, 'translate-x-[0.4rem]']
            "
        ></span>
    </button>
</template>
